import { IBANContext, ITransferForm } from "@usher/pe-client-front-end-lib"
import { PropsWithChildren, useContext } from "react"
import { useFormContext } from "react-hook-form"
import { PaymentSystemLogo } from "../../../PaymentSystemLogo"
import { FormRow } from "./FormRow"

const Row = ({ title, children }: PropsWithChildren<{ title: string }>) => {
  return (
    <div className="flex text-base py-2 flex-col md:flex-row">
      <p className="text-gray-400 flex-1">{title}</p>
      <div className="text-black text-left flex-1">{children}</div>
    </div>
  )
}
export const TransferDetails = () => {
  const { paymentSystem, currency } = useContext(IBANContext)
  const { getValues } = useFormContext<ITransferForm>()
  const state = getValues()
  return (
    <div className="transfer-details">
      <FormRow
        title={
          <div className="flex items-start">
            <PaymentSystemLogo className="inline-block md:hidden" />
            <h1>Transfer Details (Outgoing Transfer)</h1>
            <PaymentSystemLogo className="hidden md:inline-block ml-2" />
          </div>
        }
      >
        <div className="max-w-[600px] flex flex-col gap-[5px]">
          <Row title="Payment System">{paymentSystem}</Row>
          <Row title="Transfer Amount">
            {state.amount} {currency}
          </Row>
          <Row title="Created Date">{new Date().toLocaleDateString()}</Row>
          <Row title="Transfer Reason">{state.reason}</Row>
        </div>
      </FormRow>
      <FormRow title="Receiver's Info">
        <div className="max-w-[600px] flex flex-col gap-[5px]">
          <Row title="Beneficiary Name">{state.beneficiary_name}</Row>
          <Row title="Address Line">{state.receiver_address}</Row>
          <Row title="Address Line 2">{state.receiver_address2}</Row>
          {/* @ts-ignore */}
          <Row title="Country">{state.receiver_country.label}</Row>
          <Row title="State">{state.receiver_state?.label || "N/A"}</Row>
          <Row title="City">{state.receiver_city || "N/A"}</Row>
          <Row title="ZIP">{state.receiver_zip || "N/A"}</Row>
          <Row title="IBAN/Account Number">{state.iban_account_number}</Row>
        </div>
      </FormRow>
      <FormRow title="Receiver's Bank Info">
        <div className="max-w-[600px] flex flex-col gap-[5px]">
          <Row title="Bank Name">{state.bank_name}</Row>
          <Row title="SWIFT/BIC">{state.swift}</Row>
          <Row title="Country">{state.bank_country.label}</Row>
          <Row title="State">{state.receiver_bank_state?.label || "N/A"}</Row>
          <Row title="City">{state.receiver_bank_city || "N/A"}</Row>
          <Row title="ZIP">{state.receiver_bank_zip || "N/A"}</Row>
          <Row title="Address Line">{state.address}</Row>
          <Row title="Address Line 2">{state.address2 || "N/A"}</Row>
        </div>
      </FormRow>
    </div>
  )
}
